// frontend/src/api/contentBlocks.api.ts
import api from './axios';

export interface ContentBlockTranslation {
  title: string;
  content: string;
}

export interface ContentBlock {
  id: number;
  property_id: number;
  sort_order: number;
  is_active: boolean;
  icon: string;
  icon_color: string;
  translations: {
    en?: ContentBlockTranslation;
    ru?: ContentBlockTranslation;
    zh?: ContentBlockTranslation;
    th?: ContentBlockTranslation;
    he?: ContentBlockTranslation;
  };
}

export const contentBlocksApi = {
  // Get all content blocks for a property
  getPropertyBlocks: async (propertyId: number): Promise<ContentBlock[]> => {
    const response = await api.get(`/properties/${propertyId}/content-blocks`);
    return response.data.data;
  },

  // Create a new content block
  createBlock: async (
    propertyId: number,
    data: { translations: ContentBlock['translations']; is_active?: boolean; icon?: string; icon_color?: string }
  ): Promise<{ id: number }> => {
    const response = await api.post(`/properties/${propertyId}/content-blocks`, data);
    return response.data.data;
  },

  // Update a content block
  updateBlock: async (
    propertyId: number,
    blockId: number,
    data: { translations?: ContentBlock['translations']; is_active?: boolean; icon?: string; icon_color?: string }
  ): Promise<void> => {
    await api.put(`/properties/${propertyId}/content-blocks/${blockId}`, data);
  },

  // Delete a content block
  deleteBlock: async (propertyId: number, blockId: number): Promise<void> => {
    await api.delete(`/properties/${propertyId}/content-blocks/${blockId}`);
  },

  // Reorder content blocks
  reorderBlocks: async (propertyId: number, blockIds: number[]): Promise<void> => {
    await api.put(`/properties/${propertyId}/content-blocks/reorder`, { blockIds });
  },

  // Upload image for content block
  uploadImage: async (file: File): Promise<string> => {
    const formData = new FormData();
    formData.append('image', file);
    const response = await api.post('/content-blocks/upload-image', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data.data.url;
  }
};

export default contentBlocksApi;
